<template>
  <div id="instagram-hashtag-page">
    <h6 class="m-t-0 m-b-20">
      <i class="bi bi-instagram"></i> Instagram Tagar
      <i class="bi bi-question-circle text-blue" v-tooltip.right="{ ref: 'igHelper' }"></i>
      <button v-if="isAdmin" id="tambah-hashtag" class="btn btn-icon-left btn-warning pull-right" @click="addHashtag">
        <i class="bi bi-plus"></i> Tambah Tagar
      </button>
    </h6>
    <div ref="igHelper" class="tooltip-content">
      <p>
        Daftar <b>Instagram Tagar</b> yang akan dimonitor. Masukan Tagar
        yang ingin Anda monitor datanya pada section ini.
      </p>
      <p>Tagar ini khusus untuk crawler instagram.</p>
    </div>

    <div class="table-wrapper">
      <table class="table table-hover table-condensed" id="daftar-hashtag" style="width: 100%">
        <thead>
          <tr>
            <th>Tagar</th>
            <th v-if="isAdmin" width="10%" class="text-center">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="is_loading">
            <td colspan="2" align="center">Loading...</td>
          </tr>
        </tbody>
      </table>
    </div>
    <modal-dynamic-component v-if="modal" :key="modal_key" :modal="modal" :static="true" />
    <v-tour v-if="tour_steps.length > 0" name="myTour" :steps="tour_steps" :options="{ highlight: true }"></v-tour>
  </div>
</template>

<script>
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modal_add_hashtag from "@/views/components/settings/keyword/modal_add_hashtag.vue";
import swal from "sweetalert";

export default {
  name: "tab_instagram_hashtag",
  components: {
    "modal-dynamic-component": modal_dynamic,
  },
  data() {
    return {
      tour_steps: [],
      modal: null,
      modal_key: 0,
      table: null,
      id_project:
        this.$store.getters.user.id_project != 0
          ? this.$store.getters.user.id_project
          : parseInt(atob(this.$route.query.ref)),
      data_hashtag: null,
      is_loading: true,
    };
  },
  methods: {
    getHashtag: function () {
      let api = process.env.VUE_APP_API_URL + "ig-hashtags/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.data_hashtag = response.data;
            this.generateTable("#daftar-hashtag", this.data_hashtag);
          } else {
            this.generateTable("#daftar-hashtag", []);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addHashtag: function () {
      this.modal = {
        title: "Tambah Tagar",
        subtitle: "Silahkan masukan Tagar tanpa menggunakan tanda '#'",
        component: modal_add_hashtag,
      };
      this.modal_key++;
    },
    deleteHashtag: function (hashtag) {
      let self = this;
      swal({
        title: "Apakah anda yakin?",
        text: "Anda akan menghapus kata kunci #" + hashtag,
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
      }).then((yess) => {
        if (yess) {
          let params = {
            _id: this.id_project,
            hashtag: hashtag,
          };
          let api = process.env.VUE_APP_API_URL + "hashtag-delete";
          this.$http
            .post(api, params)
            .then(function (response) {
              if (response.status == 200) {
                self
                  .$("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Tagar berhasil dihapus.',
                    position: "top",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
                self.getHashtag();
              }
            })
            .catch(function () {
              self
                .$("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat menghapus Tagar. data tidak sync ataupun lainya',
                  position: "top",
                  timeout: 5000,
                  type: "danger",
                })
                .show();
            });
        }
      });
    },
    generateTable: function (id, data) {
      if (this.isAdmin) {
        this.table = this.$(id).DataTable({
          destroy: true,
          data: data,
          language: {
            // emptyTable: "Mohon maaf, data tidak tersedia!",
            search: "Cari:",
            zeroRecords: "Data tidak tersedia",
            info: "Menampilkan halaman _PAGE_ dari _PAGES_",
            infoEmpty: "Menampilkan 0 data",
            lengthMenu: "Tampilkan _MENU_ data",
            "paginate": {
              "next": "Lanjut",
              "previous": "Sebelum"
            }
          },
          columns: [{ data: "hashtag" }, { data: "action" }],
          columnDefs: [
            {
              render: function (data, type, row) {
                return "#" + row;
              },
              targets: 0,
            },
            {
              render: function (data, type, row) {
                let btn =
                  '<center><button id="hapus-hashtag" class="btn btn-danger btn-sm del" data-id="' +
                  row.topic_id +
                  '"><i class="bi bi-trash"></i></button></center>';
                return btn;
              },
              orderable: false,
              targets: 1,
            },
          ],
        });
      } else {
        this.table = this.$(id).DataTable({
          destroy: true,
          data: data,
          language: {
            // emptyTable: "Mohon maaf, data tidak tersedia!",
            search: "Cari:",
            zeroRecords: "Data tidak tersedia",
            info: "Menampilkan halaman _PAGE_ dari _PAGES_",
            infoEmpty: "Menampilkan 0 data",
            lengthMenu: "Tampilkan _MENU_ data",
            "paginate": {
              "next": "Lanjut",
              "previous": "Sebelum"
            }
          },
          columns: [{ data: "hashtag" }],
          columnDefs: [
            {
              render: function (data, type, row) {
                return "#" + row;
              },
              targets: 0,
            },
          ],
        });
      }
    },
  },
  computed: {
    isAdmin: function () {
      let user_role = this.$store.getters.user.role;
      if (user_role == 1 || user_role == 2) {
        return true;
      }
      return false;
    },
  },
  mounted: function () {
    this.getHashtag();
    let self = this;
    this.$("#daftar-hashtag tbody").on("click", ".del", function () {
      var tr = self.$(this).closest("tr");
      var data = self.table.row(tr).data();
      let hashtag_to_delete = data.replace("#", "");
      self.deleteHashtag(hashtag_to_delete);
    });
    let v_step = [];
    v_step[0] = {
      target: "#tab-vertical",
      header: {
        title: "Tab Menu",
      },
      content: `Anda dapat memilih salah satu untuk melihat detail dari menu.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#tambah-hashtag",
      header: {
        title: "Tombol Tambah Hashtag",
      },
      content: `Klik untuk menambahkan data hashtag instagram baru.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[2] = {
      target: "#daftar-hashtag_filter",
      header: {
        title: "Cari Item Tabel",
      },
      content: `Masukkan kata kunci untuk mencari instagram hashtag yang diinginkan.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[3] = {
      target: "#daftar-hashtag",
      header: {
        title: "Tabel Instagram Hashtag",
      },
      content: `Menampilkan daftar instagram hashtag tersedia.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[4] = {
      target: "#hapus-hashtag",
      header: {
        title: "Tombol Hapus Hashtag",
      },
      content: `Klik untuk menghapus instagram hashtag yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };

    this.tour_steps = v_step;
  },
};
</script>